import getOr from "lodash/fp/getOr";
import { GLOBAL_CONSTANTS } from "../../global/constants";
import { MarketRanking } from "../../models/marketRanking";
import { marketRank } from "../../utils/api";
import { initTrackMarketRank, initTrackMarketRankCompare } from "../../utils/track";
import { getCountryDetail } from "../../utils/utils";
import { showLimit } from "./searchBar";

const $ = window.$;
const MAX_COMPARE = 5;

const contentBox = $('.section-market-ranking .content-box');
const headBox = $('.section-market-ranking .content-box .head');
const next = $('.section-market-ranking .content-box .next');
const blurRight = $('.section-market-ranking .content-box .blur.right');
const back = $('.section-market-ranking .content-box .back');
const slider = $('.section-market-ranking .content-box .data .slider');
const dataBox = $('.section-market-ranking .content-box .data');

const contentBoxCompare = $('.section-market-ranking-compare .content-box');
const headBoxCompare = $('.section-market-ranking-compare .content-box .head');
const nextCompare = $('.section-market-ranking-compare .content-box .next');
const blurRightCompare = $('.section-market-ranking-compare .content-box .blur.right');
const backCompare = $('.section-market-ranking-compare .content-box .back');
const sliderCompare = $('.section-market-ranking-compare .content-box .data .slider');
const dataBoxCompare = $('.section-market-ranking-compare .content-box .data');

export function loadData(data = []) {
  window.marketRank = data;
  window.marketRankCompare = [];
  window.marketRankCompareData = [];
  window.moreCompare = [];
  let html = '';
  data.forEach(element => {
    html += element.genHtml();
  });
  slider.html(html);
  initTrackMarketRank();
  $(".section-market-ranking").css('display', 'block');
  slider.css('transform', `translateX(0)`);
  setTimeout(setUpClass, 600);
  setUpSlider();
}

export function setUpMarketRank() {
  if (!contentBox.length) {
    return;
  }
  setUpSlider();
  $(window).on('resize', function () {
    setUpSlider();
  });
  next.on('click', function () {
    const maxWidth = contentBox.width() - headBox.width();
    const width = Math.floor(maxWidth / 191) * 191;
    const left = slider.position().left - 191;
    if (left + slider.width() < width || left % 191 !== 0) {
      return;
    }
    slider.css('transform', `translateX(${left}px)`);
    setTimeout(setUpClass, 600);
  });
  back.on('click', function () {
    const left = slider.position().left + 191;
    if (left > 0 || left % 191 !== 0) {
      return;
    }
    slider.css('transform', `translateX(${left}px)`);
    setTimeout(setUpClass, 600);
  });
  $('.section-market-ranking .content-box .head .compare button').on('click', function () {
    onCompare();
  });

  $('.section-market-ranking-compare .go-back').on('click', function () {
    $('.main-page').removeClass('compare');
    $('.section-market-ranking .content-box .data .slider .item .compare input[name=compare]:checked').prop('checked', false);
    setUpSlider();
  });

  $('body').on('change', '.section-market-ranking .content-box .data .slider .item .compare input[name=compare]', function () {
    if (this.checked && $('.section-market-ranking .content-box .data .slider .item .compare input[name=compare]:checked').length > MAX_COMPARE) {
      $(this).prop('checked', false);
    }
  })

  setupCompare();
}

export function setUpSlider() {
  const maxWidth = contentBox.width() - headBox.width();
  // const width = Math.floor(maxWidth / 191) * 191;
  next.css('left', (maxWidth + 216) + 'px');
  blurRight.css('left', (maxWidth + 192) + 'px');
  dataBox.width(maxWidth);
  setUpClass();
}

export function setUpClass() {
  const maxWidth = contentBox.width() - headBox.width();
  const width = Math.floor(maxWidth / 191) * 191;
  if (slider.width() + slider.position().left > width) {
    contentBox.addClass('next');
  } else {
    contentBox.removeClass('next');
  }

  if (slider.position().left < 0) {
    contentBox.addClass('back');
  } else {
    contentBox.removeClass('back');
  }
}

export function setUpSliderCompare() {
  const maxWidth = contentBoxCompare.width() - headBoxCompare.width();
  // const width = Math.floor(maxWidth / 191) * 191;
  nextCompare.css('left', (maxWidth + 216) + 'px');
  blurRightCompare.css('left', (maxWidth + 192) + 'px');
  dataBoxCompare.width(maxWidth);
  setUpClassCompare();
}

export function setUpClassCompare() {
  const maxWidth = contentBoxCompare.width() - headBoxCompare.width();
  const width = Math.floor(maxWidth / 191) * 191;
  if (sliderCompare.width() + sliderCompare.position().left > width) {
    contentBoxCompare.addClass('next');
  } else {
    contentBoxCompare.removeClass('next');
  }

  if (sliderCompare.position().left < 0) {
    contentBoxCompare.addClass('back');
  } else {
    contentBoxCompare.removeClass('back');
  }
}

export function onCompare() {
  const list = [];
  $('.section-market-ranking .content-box .data .slider .item .compare input[name=compare]:checked').each(function (i, obj) {
    list.push($(obj).val());
  });
  window.marketRankCompare = list;
  getCompare();
}

export function getCompare() {
  window.marketRankCompareData = [];
  let needMore = false;
  for (let i = 0; i < MAX_COMPARE; i++) {
    if (window.marketRankCompare[i]) {
      const localData = MarketRanking.getData(window.marketRank, window.moreCompare, window.marketRankCompare[i]);
      if (localData) {
        window.marketRankCompareData.push(localData);
      } else {
        needMore = true;
        break;
      }
    } else {
      window.marketRankCompareData.push(MarketRanking.fromApiObject({}))
    }
  }
  if (needMore) {
    loadMoreCompare()
  } else {
    genCompare();
  }
}

export function genCompare() {
  let html = ``;
  for (let i = 0; i < window.marketRankCompareData.length; i++) {
    const element = window.marketRankCompareData[i];
    html += element.genHtml(i);
  }
  $('.section-market-ranking-compare .content-box .data .slider').html(html);
  $('.section-market-ranking-compare .content-box .data .slider .item .border-box .country select').selectize({
    placeholder: "Choose country",
    searchField: ['value', 'text', 'iso2', 'iso3'],
    onDropdownOpen: function () {
      this.latest = this.getValue() || this.latest;
      this.$input.get(0).selectize.clear(true);
    },
    onBlur: function () {
      if (this.getValue() === '') {
        this.setValue(this.latest);
      }
    },
    onChange: function (value) {
      if (value && value !== this.latest) {
        window.marketRankCompare[this.$input.attr('data-index')] = this.getValue();
        getCompare();
      }
    },
  });
  initTrackMarketRankCompare();
  $('.main-page').addClass('compare');
  setUpSliderCompare();
}

export function setupCompare() {
  setUpSliderCompare();
  $(window).on('resize', function () {
    setUpSliderCompare();
  });
  nextCompare.on('click', function () {
    const maxWidth = contentBoxCompare.width() - headBoxCompare.width();
    const width = Math.floor(maxWidth / 191) * 191;
    const left = sliderCompare.position().left - 191;
    if (left + sliderCompare.width() < width || left % 191 !== 0) {
      return;
    }
    sliderCompare.css('transform', `translateX(${left}px)`);
    setTimeout(setUpClassCompare, 600);
  });
  backCompare.on('click', function () {
    const left = sliderCompare.position().left + 191;
    if (left > 0 || left % 191 !== 0) {
      return;
    }
    sliderCompare.css('transform', `translateX(${left}px)`);
    setTimeout(setUpClassCompare, 600);
  });
  $('body').on('click', '.section-market-ranking-compare .content-box .data .slider .item .remove-box', function () {
    const index = $(this).attr('data-index') * 1;
    window.marketRankCompare[index] = undefined;
    window.marketRankCompareData[index] = MarketRanking.fromApiObject({});
    getCompare();
  })
}

export function loadMoreCompare() {
  marketRank({
    origin: getCountryDetail(window.searchData.export).iso2,
    product: window.searchData.hs,
    destinations: window.marketRankCompare.filter(Boolean)
  }, function (data) {
    if (data.length) {
      window.moreCompare = data;
      getCompare();
    }
  }, function (error) {
    const errorCode = getOr('', 'error_code')(error);
    if (errorCode === GLOBAL_CONSTANTS.ERROR_CODE.LIMIT) {
      showLimit();
    }
    console.error(error);
  });
}